import React from "react"
import useSwr from "swr"
import { getGame } from "../../../api/sanity"
import { useParams } from "react-router"
import { Box, Heading, Layout } from "@staccx/bento"
import GameEndedResults from "../Game.Ended.Results"

const GameEnded = () => {
  const { id } = useParams()
  const { data: game, error } = useSwr(`game/${id}`, () => getGame(id))

  return (
    <Box variant="game">
      <Layout variant="flex">
        <Heading level={2} variant="grace">
          Dette spillet er over. Takk for at du spilte...
        </Heading>
        <GameEndedResults game={game} />
        {error && error.message}
      </Layout>
    </Box>
  )
}

export default GameEnded
